import { loadMyKitCookie } from "./load-my-kit-cookie";
import { parseKey } from "./my-kit-utils";

export function updateMyKitFormInput() {
    const input = document.getElementById("form-input-myKit");
    if (!input) return;

    const myKit = loadMyKitCookie();
    const keys = Object.keys(myKit || {});
    if (keys.length === 0) {
        input.value = "";
        return;
    }

    const formatted = keys.map((key) => {
        const { id, variant } = parseKey(key);
        const data = myKit[key] || {};
        return {
            id,
            variant: variant || undefined,
            quantity: Math.max(1, Number(data.quantity ?? 1))
        };
    });

    input.value = JSON.stringify(formatted);
}
